import { render } from "./configure_bill.vue?vue&type=template&id=8889ce34&scoped=true"
import script from "./configure_bill.vue?vue&type=script&lang=js"
export * from "./configure_bill.vue?vue&type=script&lang=js"

import "./configure_bill.vue?vue&type=style&index=0&id=8889ce34&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8889ce34"]])

export default __exports__